// extracted by mini-css-extract-plugin
export default {"exemplarResponseHeading":"ExemplarResponse__exemplarResponseHeading___Zasel fonts__whitney-bold___Hcpj8","exemplarResponse":"ExemplarResponse__exemplarResponse___Mp4p_"};